// extracted by mini-css-extract-plugin
module.exports = {"root":"discoverTab_root__Sh0Nx","list":"discoverTab_list__nQzDP","tab":"discoverTab_tab__33WPr","tabLabel":"discoverTab_tabLabel__t5iJ9","panel":"discoverTab_panel__owFwQ"};